/**
 * Takes jQuery key/value pair and returns a suitable email body
 * @param formFieldArray
 */
export const formTemplate = (formFieldArray: JQuerySerializeArrayElement[]) => {
    // Filter fields starting with 'formFields' (dynamic fields from the CMS)
    const formFields = formFieldArray.filter(({name}) => name.startsWith('formFields'));

    // Retrieve key from brackets in formFields and replace all underscores with spaces
    let emailBody = ``;
    for (const formField of formFields) {
        const key = formField.name.match(/\[(.*?)]/);
        emailBody += `${key[1].replace(/_/g, ' ')}: ${formField.value}\r\n`;
    }

    // Return formatted emailBody
    return emailBody;
};
